import {getCorrectDayTwoDayDelivery} from '@optimaxdev/utils';
import {SagaIterator} from 'redux-saga';
import {call, select, takeEvery, fork} from 'redux-saga/effects';

import {STEPS} from 'desktop/pages/checkout/constants/checkout';

import {SHIPPING_METHODS_CODES} from 'desktop/pages/checkout/constants/deliveryStep';

import {setOptionShippingMethod} from '../../reducers/analytics/analytics';
import {startCheckoutSaga} from '../../reducers/sagaStep/sagaStep';
import {getCurrentStep} from '../../selectors/currentStep/currentStep';
import {
    getNextDayShippingMethod,
    getSelectedShippingMethod,
} from '../../selectors/shippingMethods/shippingMethods';

import checkoutOptionSaga, {
    prepareDataForPush,
    sendCheckoutStep,
    STEP,
} from './checkoutOption/checkoutOption';

/**
 * Send event for step when skipping the first step
 */
export function* startSendingCheckoutStep(): SagaIterator {
    const currentStep = yield select(getCurrentStep);
    if (currentStep !== STEPS.DELIVERY_STEP) return;
    yield call(sendCheckoutStep);
}

/**
 * Send delivery step info to dataLayer
 */
export function* sendDeliveryStep(): SagaIterator {
    const {code, title} = yield select(getSelectedShippingMethod);
    const nextDayShippingMethod = yield select(getNextDayShippingMethod);
    const twoDayDeliveryDay =
        nextDayShippingMethod?.additionalData &&
        getCorrectDayTwoDayDelivery(nextDayShippingMethod?.additionalData?.day);

    const checkedOption =
        code === SHIPPING_METHODS_CODES.NEXT_DAY
            ? `${title} - ${twoDayDeliveryDay === 'tomorrow' ? 'Tomorrow' : 'Other'}`
            : title;
    yield call(prepareDataForPush, STEP[STEPS.DELIVERY_STEP], checkedOption);
}

/**
 * Checkout option saga
 */
export function* eecAnalyticsRootSaga() {
    yield takeEvery(`${startCheckoutSaga}`, startSendingCheckoutStep);
    yield takeEvery(`${setOptionShippingMethod}`, sendDeliveryStep);
    yield fork(checkoutOptionSaga);
}
